module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 6
// module chunks = 0